module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "suitCase-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina vitrinaSuitcase"
  }, [_c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Descripción:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataLocal.dataShipment.description))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataLocal.dataShipment.destination.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Operador de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataLocal.dataShipment.reciever_operator.attributes.username))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de salida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataLocal.dataShipment.arrival_date)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataLocal.dataShipment.departure_date)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient2",
      "aria-labelledby": "headingclient2"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataLocal.dataLuggage.luggage_items), function(luggageItem) {
    return _c('li', [_c('cardDetailLuggage', {
      attrs: {
        "dataLuggage": luggageItem
      }
    })], 1)
  }), 0)])])])])])])])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient3",
      "aria-labelledby": "headingclient3"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    class: _vm.sortedClass('equipaje'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('equipaje')
      }
    }
  }, [_vm._v("Equipaje")]), _vm._v(" "), _c('th', {
    class: _vm.sortedClass('numeroOrden'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('numeroOrden')
      }
    }
  }, [_vm._v("Número de Orden")]), _vm._v(" "), _c('th', {
    class: _vm.sortedClass('cantidad'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('cantidad')
      }
    }
  }, [_vm._v("Cantidad")]), _vm._v(" "), _c('th', {
    class: _vm.sortedClass('precioDeclarado'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('precioDeclarado')
      }
    }
  }, [_vm._v("Precio Declarado")]), _vm._v(" "), _c('th', {
    class: _vm.sortedClass('peso'),
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('peso')
      }
    }
  }, [_vm._v("Peso")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedItems), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.equipaje))]), _vm._v(" "), _c('td', [_vm._v("#" + _vm._s(item.numeroOrden) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cantidad))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(item.precioDeclarado) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.peso) + " Kg")])])
  }), 0)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalWeightLb)) + " Kg")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showModalConfirmation
    }
  }, [_vm._v("Despachar embarque")])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toSendForm()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Resumen del embarque")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos del embarque")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient2",
      "data-toggle": "collapse",
      "data-target": "#collapseclient2",
      "aria-expanded": "false",
      "aria-controls": "collapseclient2"
    }
  }, [_c('span', [_vm._v("Detalles de equipaje")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient3",
      "data-toggle": "collapse",
      "data-target": "#collapseclient3",
      "aria-expanded": "false",
      "aria-controls": "collapseclient3"
    }
  }, [_c('span', [_vm._v("Detalle de paquetes")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ea375d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/elements/form-4-create-shipment.vue
// module id = 1894
// module chunks = 1